/// <reference path='../_references.ts'/>

module App.HeaderMessages {
	angular.module('headerMessages', [])
		.service('HeaderMessagesService', HeaderMessagesService)
		.controller('HeaderMessagesController', HeaderMessagesController);
}
